import React, { useEffect, useState } from "react";
import { Table } from "../../../_helpers/Table";
import { useNavigate, useOutletContext } from "react-router-dom";
import { getUsers } from "../../../_api/Admin";
import { Loader } from "../../../_helpers/components/Forms/Loader";
import { firstLetterCapital } from "../../../_helpers/functions";
import toast from "react-hot-toast";
import { Button } from "../../../_helpers/components/Button";

const ListIndividual = () => {
    const navigate = useNavigate();
    const [user, setUser, currentApp, currentMenu, currentTab, setCurrentTab, setCurrentMenu] = useOutletContext();
    const features_right = user.policy.rights[currentApp][currentMenu.id]["sub_menu"]["INFOS"]["features"];
    const [individuals, setIndividuals] = useState([]);
    const [filteredIndividuals, setFilteredIndividuals] = useState([]);
    const [searchUsers, setSearchUsers] = useState([]);

    const [isLoading, setIsLoading] = useState(false);
    const [etablissements, setEtablissements] = useState([]);
    const [selectedEtablissement, setSelectedEtablissement] = useState("all");

    const loadUsers = async () => {
        setIsLoading(true);
        await getUsers().then((resp) => {
            const content = Array.isArray(resp.data) ? resp.data : resp.data[0];

            const etablissementsSet = new Set();
            const users = content?.map((user) => {
                // récupérer tous les noms d’établissements
                user.establishments.forEach((es) =>
                    etablissementsSet.add(es.name)
                );

                return {
                    value: user.id,
                    label: user.last_name,
                };
            });

            setSearchUsers(users);
            setEtablissements(Array.from(etablissementsSet));

            const res = content.sort((a, b) => a.last_name < b.last_name ? -1 : (a.last_name == b.last_name && a.first_name < b.first_name ? -1 : 1)).map((individual) => {
                const textTeam = individual.teams.map((team) =>
                    firstLetterCapital(team.name)
                );

                return {
                    row: [
                        individual.last_name?.toUpperCase(),
                        individual.first_name || "",
                        individual.category?.name,
                        individual.matricule_number?.toUpperCase(),
                        textTeam.join(" | "),
                    ],
                    data: individual,
                };
            });
            setIndividuals(res);
            setFilteredIndividuals(res); // initialement tout
        });
        setIsLoading(false);
    };

    const headers = ["Nom", "Prénom", "Catégories", "Matricule", "Services"];

    useEffect(() => {
        loadUsers();
    }, []);

    const rowClick = (value) => {
        navigate("/team/" + value.id + "#informations");
    };

    const selectSearch = (item) => {
        navigate("/team/" + item.value + "#informations");
    };

    const handleSelectEtablissement = (e) => {
        const selected = e.target.value;
        setSelectedEtablissement(selected);

        if (selected === "all") {
            setFilteredIndividuals(individuals);
        } else {
            const filtered = individuals.filter((ind) =>
                ind.data.establishments.some(
                    (es) => es.name.toLowerCase() === selected.toLowerCase()
                )
            );
            setFilteredIndividuals(filtered);
        }
    };

    return (
        <div className="min-h-full bg-gray-50">
            {/* Header */}
            <div className="bg-white border-b border-gray-200 shadow-sm">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
                    <div className="flex items-center justify-between flex-wrap gap-4">
                        <div>
                            <h1 className="text-3xl font-bold text-gray-900">
                                Liste du personnel
                            </h1>
                            <p className="mt-2 text-sm text-gray-600">
                                Consultez et gérez les informations des membres de votre équipe
                            </p>
                        </div>
                        {features_right["add_employe"] && (
                            <div>
                                <Button
                                    action={() => navigate("/team/form/create")}
                                    name={"Ajouter un salarié"}
                                />
                            </div>
                        )}
                    </div>
                </div>
            </div>

            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
                {/* Filtres */}
                {etablissements.length > 1 && (
                    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6">
                        <div className="flex items-center gap-4">
                            <label
                                htmlFor="etablissement"
                                className="text-sm font-medium text-gray-700 whitespace-nowrap"
                            >
                                Établissement :
                            </label>
                            <select
                                id="etablissement"
                                value={selectedEtablissement}
                                onChange={handleSelectEtablissement}
                                className="block appearance-none w-full sm:w-auto min-w-[200px] bg-white border border-gray-300 text-gray-700 py-2 px-4 pr-8 rounded-lg leading-tight focus:outline-none focus:ring-2 focus:ring-app-primary focus:border-app-primary"
                            >
                                <option value="all">Tous les établissements</option>
                                {etablissements.map((etab, index) => (
                                    <option key={index} value={etab}>
                                        {firstLetterCapital(etab)}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                )}

                {/* Table */}
                <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
                    {isLoading ? (
                        <div className="flex items-center justify-center py-20">
                            <div className="text-center">
                                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-app-primary mx-auto mb-4"></div>
                                <p className="text-gray-600 font-medium">Chargement des données...</p>
                            </div>
                        </div>
                    ) : (
                        <Table
                            headers={headers}
                            rows={filteredIndividuals}
                            onClick={rowClick}
                            searchable={true}
                            searchAction={selectSearch}
                            searchData={searchUsers}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

export default ListIndividual;
